import { FILTER_MATCH_MODES } from '../../constants';
import { FilterItemType } from '../../types/types';
import { resolveFilterMatchModeType } from './resolveFilterMatchModeType';

const getModesByType = (
  type: string | undefined
): typeof FILTER_MATCH_MODES => {
  if (!type) {
    return [];
  }

  return FILTER_MATCH_MODES.filter(({ types }) => types.includes(type));
};

export const getFilterMatchModes = (
  filterItem: Pick<FilterItemType, 'type' | 'control'> | undefined,
  fallbackType?: string
): typeof FILTER_MATCH_MODES => {
  const modes = getModesByType(
    resolveFilterMatchModeType(filterItem?.type, filterItem?.control)
  );

  if (modes.length > 0 || !fallbackType) {
    return modes;
  }

  return getModesByType(fallbackType);
};
